import _ from 'lodash';
import { memo, ReactElement } from 'react';

import { Box, Divider } from '@breathelife/mui';
import { RenderingSubsection } from '@zinnia/form-engine-sdk';

import { SubsectionView } from './SubsectionView';

interface SubsectionContainerProps {
  subsection: RenderingSubsection;
}

export const SubsectionContainer = memo(InnerSubsectionContainer);

export function InnerSubsectionContainer(props: SubsectionContainerProps): ReactElement {
  const { subsection } = props;

  return (
    <Box>
      <Divider />
      <Box display='flex' flexDirection='column' pt={4} id={_.kebabCase(subsection.title)}>
        <SubsectionView subsection={subsection} />
      </Box>
    </Box>
  );
}
